import { Global } from '../../global';
import { DariCalendarService } from '../../../services/DariCalendar';
import { Component, OnInit } from '@angular/core';
import { ReportService } from '../../../services/Acc_ReportService';
import { UtilityService } from '../../../services/Acc_Utility.service';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import { forkJoin } from "rxjs/observable/forkJoin";
import { DatePipe } from '@angular/common';
import * as moment from 'jalali-moment';
import { forEach } from '@angular/router/src/utils/collection';
import { GL_MasterService } from '../../../services/Acc_GL_Master.service';

@Component({
  selector: 'app-income-statement-account',
  templateUrl: './income-statement-account.component.html',
  styleUrls: ['./income-statement-account.component.css']
})
export class IncomeStatementAccountComponent implements OnInit {

  ArrLabels: any;
  labels: any = {};
  fromDate: string;
  fromDate_DariDate: string;
  ToDate:string;
  ToDate_DariDate: string;

  //incomes:incomestatement[];
  incomes:any=[];
  expenses:any=[];

  totalIncome:number;
  totalExpense:number;
  netIncome:number;

  constructor(
    private ReportService: ReportService,
    private DariCalendar: DariCalendarService,
    private UtilityService: UtilityService,
    private GL_MasterService: GL_MasterService,
    private global:Global,
    private dateConverter: DatePipe
  ) {
     this.totalIncome = 0;
    this.totalExpense = 0;
    this.netIncome = 0 }

  ngOnInit() {
    this.getLabels();
    this.getBranchId();
    this.getGlMasters();
  }

  isBranchId: number = -1;
  userId: string = '0';
  getBranchId() {
     
    let data = localStorage.getItem('accessKeyUser');
    let dataAccess = JSON.parse(data);
    let dataAccessUrl = dataAccess.filter(f => f.accessKeyUrl == "/discount")[0];
    if (dataAccessUrl != undefined) {
      if (dataAccessUrl.isMainBranch)
        this.isBranchId = 1;
      else if (dataAccessUrl.isWestBranch)
        this.isBranchId = 2;
      else
        this.isBranchId = 0;
      this.userId = dataAccessUrl.userId
    }
  }

  selectedGL_Master_DR: "0";
  GL_MastersDR: any[] = [];
  getGlMasters() {
    this.GL_MasterService.getGL_Masters("All", this.isBranchId)
      .subscribe(response => {
        if (response) {
          this.GL_MastersDR = response;
        }
      },
        error => console.log("error --> " + error))
  }

  FromDateChanged(type: string, event: MatDatepickerInputEvent<moment.Moment>) {
    var _pdate = moment(event.value).format('jYYYY-jMM-jDD');
    var _date = moment.from(_pdate,'fa').format('YYYY-MM-DD');
    this.fromDate = _date;
    this.fromDate_DariDate = _pdate;
  }

  ToDateChanged(type: string, event: MatDatepickerInputEvent<moment.Moment>) {
    var _pdate = moment(event.value).format('jYYYY-jMM-jDD');
    var _date = moment.from(_pdate,'fa').format('YYYY-MM-DD');
    this.ToDate = _date;
    this.ToDate_DariDate = _pdate;
  }

  FetchIncomeStatement()
  {
     
    this.totalExpense = 0;
    this.totalIncome = 0;

    //let incomes = this.ReportService.IncomeStatement(this.fromDate, this.ToDate, 'income', this.isBranchId, this.userId);
    let expenses = this.ReportService.IncomeStatementAccount(this.fromDate, this.ToDate, 'expense', this.isBranchId, this.userId, this.selectedGL_Master_DR,"0");

    forkJoin([expenses]).subscribe(
      result => {
        this.expenses = result[0];
        for (var i = 0; i < this.expenses.length; i++)
        {
          if (this.expenses[i].gl_code == 'X10001' || this.expenses[i].gl_code == 'X10002') {
            this.expenses[i].turn_over = 0;
          }
          this.totalExpense += this.expenses[i].turn_over_dr;
          this.totalIncome += this.expenses[i].turn_over_cr;          
        } 
        this.expenses = this.expenses.filter(f => f.turn_over > 0);
      }
    )
  }

  getLabels(){
    this.UtilityService.getLabels('income-statement',this.global.lang)
      .subscribe(response => {
          if(response){
              this.ArrLabels = response;
              console.log(response);
              this.setLabels();
          }
      },
      error => console.log(error))
    }

  setLabels(){
    //title
    this.labels['income-statement-Title'] = this.ArrLabels.find( (o:any) => o.key === 'income-statement-Title').value;
    
    //Label
    this.labels['fromDate'] = this.ArrLabels.find( (o:any) => o.key === 'fromDate').value;
    this.labels['toDate'] = this.ArrLabels.find( (o:any) => o.key === 'toDate').value;
    this.labels['Incomes'] = this.ArrLabels.find( (o:any) => o.key === 'Incomes').value;
    this.labels['Expenses'] = this.ArrLabels.find( (o:any) => o.key === 'Expenses').value;
    this.labels['TotalIncome'] = this.ArrLabels.find( (o:any) => o.key === 'TotalIncome').value;
    this.labels['TotalExpense'] = this.ArrLabels.find( (o:any) => o.key === 'TotalExpense').value;
    this.labels['NetIncome'] = this.ArrLabels.find( (o:any) => o.key === 'NetIncome').value; 
    this.labels['AccNumber'] = this.ArrLabels.find( (o:any) => o.key === 'AccNumber').value; 
    this.labels['AccName'] = this.ArrLabels.find( (o:any) => o.key === 'AccName').value; 
    this.labels['Amount'] = this.ArrLabels.find( (o:any) => o.key === 'Amount').value; 
  
  }

}



// WEBPACK FOOTER //
// ./src/app/components/reports/income-statement-account/income-statement-account.component.ts